import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import RecentListForm from '../../components/advertisement/recentListForm'

const EditRecentList = props => {
  const { location, history } = props
  const { recentList } = location.state
  const firebaseKey = recentList.key

  return (
    <div>
      <Segment color="black">
        <Header size="large"> Edit Recent List </Header>
        <RecentListForm
          firebaseKey={firebaseKey}
          action="edit"
          recentList={recentList}
          history={history}
        />
      </Segment>
    </div>
  )
}

export default EditRecentList



// WEBPACK FOOTER //
// ./src/containers/advertisement/editRecentList.js